module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?6c8bd008756911fb19394e6e4b09e28f";